export default __webpack_public_path__ + "static/media/lato-bold.eb3fc1b7.woff2";